import React from "react";
import { faqs } from "../mock";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQ = () => {
  return (
    <section id="faq" className="py-24 bg-[#f2ece1]">
      <div className="max-w-3xl mx-auto px-6">
        <div className="reveal text-center">
          <span className="text-xs font-600 uppercase tracking-[0.25em] text-[#86233a]">Goed om te weten</span>
          <h2 className="font-display mt-4 text-4xl lg:text-5xl font-600 text-[#1d1c1a]">
            Veelgestelde vragen
          </h2>
        </div>

        <div className="reveal mt-12">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="rounded-2xl border border-[#e3d7c4] bg-white px-6 data-[state=open]:shadow-[0_15px_35px_-20px_rgba(83,14,47,0.35)] transition-shadow"
              >
                <AccordionTrigger className="text-left font-display text-xl text-[#530e2f] hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#4b4642] text-base leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
